// ─── Types ──────────────────────────────────────────────

export interface Surgeon {
  id: string;
  name: string;
  specialty: string;
  profiles: number;
  procedures: number;
  waste?: number;
  wastePerCase?: number;
  deadTimeReduced?: number;
  deadTimePerCase?: number;
  avgTurnover?: number;
  hasBaseline?: boolean;
  adoptionRate?: number;
}

export interface Procedure {
  id: string;
  name: string;
  surgeon: string;
  surgeonId?: string;
  specialty?: string;
  or: string;
  date: string;
  duration: number;
  waste?: number;
  wasteCost?: number;
  deadTime?: number;
  steps: number;
  stepsCompleted: number;
  wasteItems?: WasteItem[];
}

export interface WasteItem {
  name: string;
  count: number;
  cost: number;
  trend?: number;
}

export interface TrendPoint {
  [key: string]: unknown;
  day: string;
  procedures: number;
  supported: number;
  waste: number;
  deadTime: number;
}

export interface DeadTimePhase {
  phase: string;
  baseline: number;
  current: number;
  saved: number;
}

export interface HeatmapCell {
  day: number;
  weekday: number;
  week: number;
  value: number;
}

export interface ProjectionPoint {
  month: string;
  projected: number;
  actual: number | null;
}

// ─── Color Tokens ───────────────────────────────────────

export const C = {
  accent: '#00CFA0',
  accentDim: 'rgba(0,207,160,0.08)',
  accentBorder: 'rgba(0,207,160,0.15)',
  purple: '#7C5CFC',
  purpleDim: 'rgba(124,92,252,0.08)',
  orange: '#FF9F43',
  orangeDim: 'rgba(255,159,67,0.08)',
  red: '#FF5252',
  redDim: 'rgba(255,82,82,0.08)',
  blue: '#4FC3F7',
  blueDim: 'rgba(79,195,247,0.08)',
  gold: '#FFD93D',
  bg: '#080A0D',
  card: 'rgba(255,255,255,0.02)',
  cardBorder: 'rgba(255,255,255,0.06)',
  text: '#fff',
  textMid: 'rgba(255,255,255,0.6)',
  textDim: 'rgba(255,255,255,0.35)',
  textFaint: 'rgba(255,255,255,0.2)',
};
